/** Factory the app uses. OWNER: HUD-UI-AUDIO agent (keep the name). */
import type { AudioEngine } from '../types';
import { Bo2Audio } from './audio';

export function createAudio(): AudioEngine {
  return new Bo2Audio();
}
